import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue'
import { moduleByKeys } from '~/assets/modules'
import { useVentureId } from '~/functions/accounts'
import {
  useGetAccountQuery,
  useGetImpactGoalQuery,
  useCreateImpactGoalsMutation,
} from '~/types/types'
import { getLocale } from '~/functions/translate'

// composables and constants

export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const ventureId = useVentureId()
const locale = getLocale()

const { result: accountResult } = useGetAccountQuery({
  id: ventureId.value,
})

const venture = computed(
  () =>
    accountResult.value?.getAccount ||
    ({ modules: [], portfolioLinks: [] } as any),
)

const {
  result: impactGoalResult,
  loading,
  onResult,
  refetch,
} = useGetImpactGoalQuery(
  { ventureId: ventureId.value },
  {
    fetchPolicy: 'cache-and-network',
    errorPolicy: 'all',
    // First visit provisions the goal after a deliberate empty miss.
    // Suppress the global toast for "No row was found when one was required".
    context: { suppressUserError: true },
  },
)

const { mutate: createImpactGoal } = useCreateImpactGoalsMutation()

const impactGoal = computed(() => impactGoalResult.value?.getImpactGoal)

// Provision at most once per mount. Never hard-reload: getImpactGoal uses
// portfolio-scoped permissions, so Admin viewing an unlinked venture can
// fail forever and reload would loop.
const hasRequestedImpactGoalProvision = ref(false)

const isExpectedMissingImpactGoalError = (err: any): boolean => {
  const msg = (
    err?.graphQLErrors?.[0]?.message ||
    err?.message ||
    ''
  ).toLowerCase()
  return (
    msg.includes('no row was found when one was required') ||
    msg.includes('impact goal already exists')
  )
}

onResult(async (queryResult) => {
  if (queryResult.loading || hasRequestedImpactGoalProvision.value) return
  if (queryResult.data?.getImpactGoal) return

  hasRequestedImpactGoalProvision.value = true

  try {
    await createImpactGoal({ ventureIds: [ventureId.value] })
    await refetch()
  } catch (e: any) {
    if (isExpectedMissingImpactGoalError(e)) {
      // Goal exists but query couldn't see it (e.g. portfolio link missing),
      // or empty-state race. Stop — do not reload / rethrow to UI.
      return
    }
    throw e
  }
})

const module = computed(() =>
  moduleByKeys.impactGoals.subModules.find(
    (e) => e.id === 'impact-goals',
  ) || {}
)
const bookedModules = computed(() => venture.value?.bookedModules || [])

return { __sfc: true,ventureId, locale, accountResult, venture, impactGoalResult, loading, onResult, refetch, createImpactGoal, impactGoal, hasRequestedImpactGoalProvision, isExpectedMissingImpactGoalError, module, bookedModules }
}

})